import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import StripeCheckout from 'react-stripe-checkout';
import {my_PUBLISHABLE_stripekey,stripeInfo} from '../../../server/constants';
import { postWithHeaders} from "../../../server/actions";
import {_addNotificationError,allowNumericWithdecimal,_addNotification,
    calculateStripeCharges,
    convertTwoDecimalPoint} from "../../../server/util";
import { isNull } from 'util';
class StripeEventCheckOut extends Component {
  constructor(props){
    super(props);
    this.state={
        reqObject:this.props.reqObject,
        formatedReqObj:{}
    }
    this.onToken=this.onToken.bind();
  }
  componentWillMount=()=>{
      this.setState({formatedReqObj:this.calculateTotalFee()})
  }
  componentWillReceiveProps=(nextPros)=>{
      this.setState({reqObject:nextPros.reqObject,formatedReqObj:this.calculateTotalFee()})
  }
  calculateTotalFee=()=>{
    let requestObject={
        "transactionType": "Event",
        "purchaseItemType": "Event",
        "paymentType": "Online",
        "transactionDescription": "Buy events",    
        "appFeeAmount":stripeInfo(this.props.schoolObject.schoolId).application_free,
        "studentWiseTransactions": [],
        "parentUserEmails": sessionStorage.getItem('loggedInUserInfo'),
        "mealSchoolId": this.props.schoolObject.schoolId
      };
    let totalAmount=0.00;
    let studentWiseTransactions=[];
    Object.keys(this.state.reqObject).forEach(eventId=>{
        this.state.reqObject[eventId].studentList.forEach(student=>{
            if(parseFloat(convertTwoDecimalPoint(student.amount))>0){
                totalAmount=totalAmount+parseFloat(convertTwoDecimalPoint(student.amount))
                studentWiseTransactions.push({
                    studentRecId:student.userId,
                    transactionAmount:student.amount,
                    eventInfo:{
                        recId:eventId
                    }
                })
            } 
        })
    });
    requestObject.studentWiseTransactions=studentWiseTransactions;
    requestObject.totalTransactionAmount=totalAmount;
    requestObject.transactionFees=calculateStripeCharges(totalAmount);
    return requestObject;
  }
      onToken = (token) => {
          let me=this;
          let reqObj=this.state.formatedReqObj;
          reqObj.transactionToken= token.id;
         // me.props.showHideLoading(true);
          
            let headers = {
                'Content-Type': 'application/json'
            };
            postWithHeaders("/transactions/eventPurchaseThruOnline?access_token=", JSON.stringify(reqObj),headers).then((response) => {
              if (response.status === 200) {                 
                  me.props.onPaymentDone(response);
              } else if (!response.ok) {
                me.props.onPaymentDone(response);
                  //throw Error(response);
              }
              me.props.showHideLoading(false)
          }).catch(
              (error) => {        
                me.props.showHideLoading(false);
                me.props.onPaymentDone({status:null});        
                console.log('Payment error:',error);
              }
          );        
          }
    render(){
        return(<div style={{width:'100%'}}>
            <StripeCheckout
            name= {this.props.schoolObject.schoolName==''?'MealManage':this.props.schoolObject.schoolName}
            ComponentClass="div"
            panelLabel="Proceed To Pay" // prepended to the amount in the bottom pay button
            token={this.onToken}            
            stripeKey={my_PUBLISHABLE_stripekey}
            amount={((this.state.formatedReqObj===undefined?0.00:( parseFloat(this.state.formatedReqObj.totalTransactionAmount)+calculateStripeCharges(parseFloat(this.state.formatedReqObj.totalTransactionAmount))))*100)} // cents
            currency="USD"            
            image={((this.state.reqObject.logoUrl==null)?'':this.state.reqObject.logoUrl)==''?"https://s3.amazonaws.com/stripe-uploads/acct_1CNm8hFk5swmLb4napplication-logo-logo_mm_1.png":this.state.reqObject.logoUrl} // the pop-in header image (default none)
        > <button className="btn btn-success btn-sm btn-block" style={{ fontSize: '14px'}}>
        Pay With Card
        </button> </StripeCheckout>          
        </div>);
    }
}
export default StripeEventCheckOut;


// WEBPACK FOOTER //
// ./src/components/Parent/eventSlider/stripeEventCheckout.js